import React from 'react';
import styled, { css } from 'styled-components';

import { device } from '@styles/mediaQuery';

type ArticleHeaderProps = {
  title: string;
  align?: 'left' | 'right' | 'center';
  titleMaxWidth?: string;
  margin?: string;
  fontSize?: string;
  fontSizeL?: string;
  fontSizeM?: string;
  lineHeight?: string;
  lineHeightL?: string;
  lineHeightM?: string;
};

function ArticleHeader({
  align,
  title,
  margin,
  fontSize,
  fontSizeL,
  fontSizeM,
  lineHeight,
  lineHeightL,
  lineHeightM,
  titleMaxWidth,
}: ArticleHeaderProps) {
  return (
    <StyledHeader
      $align={align}
      $width={titleMaxWidth}
      $margin={margin}
      $fontSize={fontSize}
      $fontSizeL={fontSizeL}
      $fontSizeM={fontSizeM}
      $lineHeight={lineHeight}
      $lineHeightL={lineHeightL}
      $lineHeightM={lineHeightM}
    >
      {title}
    </StyledHeader>
  );
}

const StyledHeader = styled.h2<{
  $align?: string;
  $width?: string;
  $margin?: string;
  $fontSize?: string;
  $fontSizeL?: string;
  $fontSizeM?: string;
  $lineHeight?: string;
  $lineHeightL?: string;
  $lineHeightM?: string;
}>`
  margin: ${({ $margin }) => ($margin ? $margin : 0)};
  font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : '24px')};
  font-weight: 600;

  max-width: ${({ $width }) => $width};
  text-align: ${({ $align }) => $align};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${({ $lineHeight }) => $lineHeight};

  ${device.mobileL(css<{
    $fontSizeL?: string;
    $fontSizeM?: string;
    $lineHeightL?: string;
    $lineHeightM?: string;
  }>`
    line-height: ${({ $lineHeightM }) => $lineHeightM};
    font-size: ${({ $fontSizeM }) => ($fontSizeM ? $fontSizeM : '28px')};
  `)}

  ${device.tablet(css<{ $fontSizeL?: string; $lineHeightL?: string }>`
    line-height: ${({ $lineHeightL }) => $lineHeightL};
    font-size: ${({ $fontSizeL }) => ($fontSizeL ? $fontSizeL : '48px')};
  `)}
`;

export default ArticleHeader;
